module.exports = __webpack_public_path__ + "Simple-Line-Icons.b2892aa62b0fb2c21c8d.ttf";


//////////////////
// WEBPACK FOOTER
// C:/xampp/htdocs/sm8-v1-front/src/scss/icons/simple-line-icons/fonts/Simple-Line-Icons.ttf?-i3a2kk
// module id = ../../../../../src/scss/icons/simple-line-icons/fonts/Simple-Line-Icons.ttf?-i3a2kk
// module chunks = styles